module.exports = __webpack_public_path__ + "static/media/contact-us.96710960.png";